import React, {useRef, useState} from 'react';
import aggridUtils from "../../../../../../utils/aggrid-utils.js";
import {AgGridReact} from "ag-grid-react";
import {FaCheck, FaTrash} from "react-icons/fa";
import {FaTriangleExclamation} from "react-icons/fa6";
import projectUtils from "../../../../../../utils/project-utils.js";
import citizenService from "../../../../../../services/web/citizen-service.js";
import {toast} from "react-toastify";
import Button from "../../../../../../components/button/button.jsx";
import {format} from "date-fns";

const CitizenCredentialTable = ({credentials, setCitizen, remove = false, ...props}) => {
    const gridRef = useRef(undefined);

    const [columnDefs,] = useState([
        {
            headerName: "Nome de acesso",
            field: "identification",
            flex: 1,
            valueFormatter: ({data}) => data.isCitizen  ? "Protegido" : data.identification,
            comparator: aggridUtils.nullLastComparator
        },
        {
            headerName: "Teste",
            field: "autoCheckupDt",
            flex: 1,
            cellRenderer: ({data}) => {
                if (!data.lastLoginDt) return "";

                return (
                    <div className={"flex gap-2 items-center w-full h-full"}>
                        {
                            data.autoCheckupOk ? <FaCheck color={"#219453"}/> : <FaTriangleExclamation color={"#ed5565"}/>
                        }
                        Teste: { data.autoCheckupDt ? format(data.autoCheckupDt, 'dd/MM/yyyy HH:mm'): '(não houve)' }
                    </div>
                )
            },
            comparator: aggridUtils.agGridSimpleDateComparator
        },
        {headerName: "Último acesso", field: "lastLoginDt", flex: 1, valueFormatter: ({value}) => value ? format(value, 'dd/MM/yyyy HH:mm') : null, comparator: aggridUtils.agGridSimpleDateComparator},
        ...(remove ? [{
            headerName: "",
            field: "",
            width: 60,
            cellRendererParams: {setCitizen},
            cellRenderer: ({setCitizen, data}) => {
                const {id} = data;

                const removeCredential = () => {
                    projectUtils.swalMessage(
                        "warning",
                        "Atenção",
                        "Deseja remover a credencial?",
                        "Continuar",
                        true,
                        "Cancelar",
                        ({isConfirmed}) => {
                            if (isConfirmed) {
                                citizenService.removeCredential(id)
                                    .then(() => {
                                        setCitizen(prev => ({...prev, credentials: prev.credentials.filter(c => c.id !== id)}));
                                        toast.success("Removido com sucesso");
                                    })
                                    .catch(err => {
                                        console.error(err);
                                        projectUtils.swalErrorMessage("", "Não foi possível prosseguir.", "Ok")
                                    });
                            }
                        }
                    );
                }

                return (
                    <div className={"flex justify-center items-center h-full w-full"}>
                        <Button className={"w-7.5! h-6.25! p-0!"} target={"danger"} onClick={removeCredential} title={"Revogar acesso"}>
                            <FaTrash />
                        </Button>
                    </div>
                )
            }
        }] : [])
    ]);

    return (
        <AgGridReact
            ref={gridRef}
            rowHeight={35}
            rowData={credentials ?? []}
            columnDefs={columnDefs}
            animateRows={false}
            suppressCellFocus={true}
            gridOptions={{localeText: aggridUtils.localization()}}
            theme={aggridUtils.generalTheme()}
            {...props}
        />
    );
};

export default CitizenCredentialTable;